import React from 'react'

import { PeractoLogo } from '@peracto/peracto-ui'
import { Helmet } from 'react-helmet'

import * as S from './styled'

const LoginTwo = ({ children }) => {
    return (
        <>
            <Helmet>
                <title>Peracto</title>
            </Helmet>

            <S.Container>
                <S.Left>
                    <S.LeftInner>
                        <PeractoLogo />
                    </S.LeftInner>
                </S.Left>
                <S.Right>
                    <S.RightInner>{children}</S.RightInner>
                </S.Right>
            </S.Container>
        </>
    )
}

export default LoginTwo
